export function classes(
  ...args: (string | undefined | Record<string, boolean | undefined> | false)[]
) {
  const classnames = args.reduce(
    (acc: (string | undefined | boolean)[], cl) => {
      if (typeof cl === 'object') {
        for (var key in cl) {
          if (cl.hasOwnProperty(key) && cl[key]) acc.push(key)
        }
      } else acc.push(cl)
      return acc
    },
    [],
  )
  return classnames.filter(Boolean).join(' ')
}

export function getParentByTag(
  el: HTMLElement,
  tagName: string,
): HTMLElement | null {
  if (el.tagName.toLowerCase() === tagName.toLowerCase()) {
    return el
  }

  const parentEl = el.parentElement
  return parentEl ? getParentByTag(parentEl, tagName) : null
}
